module.exports = __webpack_public_path__ + "img/20.6428ddb3.gif";